// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_hq-a";
export var fulfillmentFormRail = "_hq-9";
export var headerTitleRow = "_hq-c";
export var orderDetailsWrapper = "_hq-7";
export var orderLinkTrigger = "_hq-2";
export var paymentInformationGrid = "_hq-h";
export var paymentSummaryColumn = "_hq-i";
export var shipmentContainer = "_hq-b";
export var shipmentDetailsMainPane = "_hq-8";
export var shipmentNavigationCard = "_hq-5";
export var shipmentNavigationRail = "_hq-3";
export var shipmentNavigationRailHeader = "_hq-4";
export var shipmentSummaryFact = "_hq-e";
export var shipmentSummaryGrid = "_hq-d";
export var shipmentSummaryMetadataRow = "_hq-f";
export var shipmentSummaryTags = "_hq-g";
export var shipmentWorkspace = "_hq-0";
export var shipmentWorkspaceContent = "_hq-6";
export var shipmentWorkspaceHeader = "_hq-1";